const isMargiela = document.querySelector('body').classList.contains('Margiela');
/**
 * Validates the attributes
 * @param {jQuery} $productContainer - DOM container for a given product
 * @returns {boolean} - [true] when valid, [false] when invalid
 */
function validation($productContainer, trigger) {
  var $attributes;
  let invalidAttributesSelect = [];
  var isPrivateSales = $('.private-sales').data('isPrivateSalesProduct');
  var isLogged = $('.private-sales').data('isloggedin');


  if (isPrivateSales && !isLogged) {
    return true;
  }

  $attributes = $productContainer.find('.variation-attribute select[class*="select-"]');
    $attributes.each(function (a) {
      let optionSelected = $(this).find('option:selected');
      if (!optionSelected || !optionSelected.data('attrValue') || optionSelected.prop('disabled')) {
        invalidAttributesSelect.push($(this).parent());
      }
  });

  if (invalidAttributesSelect.length > 0) {
    invalidAttributesSelect.forEach(function (a) {
        var select_El = a.find('select');
        select_El.focus();
        if(select_El.closest('[data-component="MMSelect"]')){
            var errorNotification_El = select_El.closest('[data-component="MMSelect"]').find('.js-error_msg');
            errorNotification_El.length > 0 ? errorNotification_El.text(errorNotification_El.data('error-msg')) : errorNotification_El.text('');
        }
    });

    return false;
  }

  $attributes.removeClass('invalid');
  $('.js-error_msg').empty();
  return true;
}

module.exports = validation;
